import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=54a5fed2&"
import script from "@/components/LogoBar/LogoBar.ts?vue&type=script&lang=ts&"
export * from "@/components/LogoBar/LogoBar.ts?vue&type=script&lang=ts&"
import style0 from "@/components/LogoBar/LogoBar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports